export default "__VITE_ASSET__C6Jy5Ua3__"